import React from 'react';
import { CoverageVehicleFields } from './VehicleFields';
import moment from 'moment';
import Rate from '../../Rate';
import numeral from 'numeral';

const VehicleEmailDetails = ({ policy, rate }) => {
	const { policyNumber } = policy;
	const { transactionDate, policyEffectiveDate, policyExpirationDate, email } = rate;
	const { action, vehicle, comprehensive, rentalReimbursement, collision, towingAndLabor, previousVehicle } = email;
	const { year, make, model, vin } = vehicle;

	return (
		<div>
			<table>
				<tr>
					<td>Policy Number: {policyNumber}</td>
					<td>
						<div>
							Effective Policy Period: {moment(transactionDate).format('L')} to {moment(policyExpirationDate).format('L')}
						</div>
						<div>
							Current Policy Period: {moment(policyEffectiveDate).format('L')} to {moment(policyExpirationDate).format('L')}
						</div>
					</td>
				</tr>
				<tr>
					<td colSpan='2'>
						<Rate rate={rate} />
					</td>
				</tr>
			</table>
			<table>
				<tr>
					<th colSpan='2'>
						Vehicle {action}: {year} {make} {model}
					</th>
				</tr>
				<tr>
					<td colSpan='2'>VIN: {vin}</td>
				</tr>
				{action !== 'Deleted' && (
					<React.Fragment>
						<tr>
							<td>Comprehensive Deductible: {comprehensive > 0 ? numeral(CoverageVehicleFields.comprehensive.options[comprehensive]).format('$0,0') : 'N/A'}</td>
							<td>Rental Car: {comprehensive > 0 ? CoverageVehicleFields.rentalReimbursement.options[rentalReimbursement] : 'N/A'}</td>
						</tr>
						<tr>
							<td>Collision Deductible: {collision > 0 ? numeral(CoverageVehicleFields.collision.options[collision]).format('$0,0') : 'N/A'}</td>
							<td>Towing and Labor: {towingAndLabor > 0 ? numeral(CoverageVehicleFields.towingAndLabor.options[towingAndLabor]).format('$0,0') : 'N/A'}</td>
						</tr>
					</React.Fragment>
				)}
			</table>

			{previousVehicle && (
				<table>
					<tr>
						<th colSpan='2'>
							Vehicle Removed: {previousVehicle.year} {previousVehicle.make} {previousVehicle.model}
						</th>
					</tr>
					<tr>
						<td colSpan='2'>VIN: {previousVehicle.vin}</td>
					</tr>

					<tr>
						<td>Comprehensive Deductible: {previousVehicle.comprehensive > 0 ? numeral(CoverageVehicleFields.comprehensive.options[previousVehicle.comprehensive]).format('$0,0') : 'N/A'}</td>
						<td>Rental Car: {previousVehicle.comprehensive > 0 ? CoverageVehicleFields.rentalReimbursement.options[previousVehicle.rentalReimbursement] : 'N/A'}</td>
					</tr>
					<tr>
						<td>Collision Deductible: {previousVehicle.collision > 0 ? numeral(CoverageVehicleFields.collision.options[previousVehicle.collision]).format('$0,0') : 'N/A'}</td>
						<td>Towing and Labor: {previousVehicle.towingAndLabor > 0 ? numeral(CoverageVehicleFields.towingAndLabor.options[previousVehicle.towingAndLabor]).format('$0,0') : 'N/A'}</td>
					</tr>
				</table>
			)}
		</div>
	);
};

export default VehicleEmailDetails;
